import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/components/index/index.vue'

Vue.use(VueRouter)


const router = new VueRouter({
    scrollBehavior: () => ({y: 0}),
    routes: [
        {
            path: '/',
            component: () => import('@/components/index/index.vue'),
            name: 'Index'
        },
        {
            path: '/company/about',
            component: () => import('@/components/company/about/index.vue'),
            name: 'About',
        },
        {
            path: '/new/index',
            component: () => import('@/components/new/index.vue'),
            name: 'New',
        }
        ,
        {
            path: '/new/detail',
            component: () => import('@/components/new/detail.vue'),
            name: 'NewDetail',
        },
        {
            path: '/contact',
            component: () => import('@/components/company/contact/index.vue'),
            name: 'Contact',
        },
        {
            name: 'Tyhzapp',
            path: '/tyhz-app',
            component: () => import('@/components/app/tyhz-app.vue'),
        },
        {
            name: 'Tygjapp',
            path: '/tygj-app',
            component: () => import('@/components/app/tygj-app.vue'),
        },
        {
            name: 'Zsgjapp',
            path: '/zsgj-app',
            component: () => import('@/components/app/zsgj-app.vue'),
        },
        {
            name: 'Jdkf',
            path: '/hotel',
            component: () => import('@/components/hardware/hotel.vue'),
        },
        {
            name: 'Znjj',
            path: '/znjj',
            component: () => import('@/components/hardware/family.vue'),
        },
        {
            name: 'Agent',
            path: '/agent',
            component: () => import('@/components/agent/index.vue'),
        },
        {
            name: 'Jobxq',
            path: '/jobxq',
            component: () => import('@/components/jobxq/index.vue'),
        },
        {
            name: 'SpaceCapsule',
            path: '/tck',
            component: () => import('@/components/tck/index.vue'),
        }
    ]
});

export default router;

